import { SUCCESS, FETCH_PRACTICAL_INFO } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_PRACTICAL_INFO, UPDATED } from '../constants/socket';

export default (state = initialState.practicalInfo, { type, payload }) => {
  switch (type) {
    case FETCH_PRACTICAL_INFO + SUCCESS:
    case SC_PRACTICAL_INFO + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
